import { TrackingDataExtractor } from './tracking-data-extractor';
import { submitEvent, submitMove } from '@otto-ec/tracking-bct';

const DATA_ATTRIBUTE_CLICK_TRACKING = 'data-ft5-offers-click-tracking';
const DATA_ATTRIBUTE_MOVE_TRACKING = 'data-ft5-offers-move-tracking';

export class EventTracking {
    public registerTracking() {
        this.registerHtmlClickTracking();
        this.registerHtmlMoveTracking();
    }

    private registerHtmlClickTracking(): void {
        this.registerClickListener(DATA_ATTRIBUTE_CLICK_TRACKING, submitEvent);
    }

    private registerHtmlMoveTracking(): void {
        this.registerClickListener(DATA_ATTRIBUTE_MOVE_TRACKING, submitMove);
    }

    private registerClickListener(dataAttributeName: string, trackFunction: typeof submitEvent | typeof submitMove) {
        const trackClickHandler = (event: MouseEvent) => {
            if (!(event.target instanceof Element)) {
                return;
            }
            this.trackWithParentsRecursive(event.target, dataAttributeName, trackFunction);
        };

        document.documentElement.addEventListener('click', trackClickHandler, { passive: true, capture: true });
    }

    /**
 *
 *
 */
    private trackWithParentsRecursive(element: Element, dataAttributeName: string, trackFunction: typeof submitEvent | typeof submitMove) {
        if (element.hasAttribute(dataAttributeName)) {
            const trackingData = TrackingDataExtractor.extractTrackingData(element, dataAttributeName);
            if (trackingData) {
                trackFunction(trackingData);
            }
        }
        if (element.parentElement) {
            this.trackWithParentsRecursive(element.parentElement, dataAttributeName, trackFunction);
        }
    }
}
